import translator from '@/locales';

const allMatchTypes = {
  EXACT: {
    property: 'E',
    label: translator.t('ADVERTISEMENT.BID.EXACT_MATCHING_TYPE'),
  },
  BROAD: {
    property: 'B',
    label: translator.t('ADVERTISEMENT.BID.BROAD_MATCHING_TYPE'),
  },
  KEYWORD: {
    property: 'K',
    label: translator.t('ADVERTISEMENT.BID.KEYWORD_MATCHING_TYPE'),
  },
};

export const matchingTypes = [
  allMatchTypes.EXACT,
  allMatchTypes.BROAD,
  allMatchTypes.KEYWORD,
];

export const campaignTypes = Object.freeze({
  SEARCH: 'S',
  DISCOVERY: 'D',
  SMART: 'B',
});

export const campaignStatus = Object.freeze({
  ENDED: 'ended',
  NOT_STARTED: 'not_started',
  PAUSED: 'paused',
  ACTIVE: 'active',
  NO_BUDGET: 'no_budget',
  REACHED_DAILY_CAP: 'reached_daily_cap',
  LOW_BUDGET: 'low_budget',
});

export const negativeMatchTypes = [allMatchTypes.EXACT, allMatchTypes.KEYWORD];
